export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10824.0aca25a2.jpg";